import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userDashboardRoute } from "../../../../utils/routes/Routes";
import { useDispatch, useSelector } from "react-redux";
import {
  selectOrder,
  setOrderDetails,
} from "../../../../redux/features/orders/orderSlice";
import {
  useCaptureOrderMutation,
  useCreateNewOrderMutation,
} from "../../../../redux/features/orders/orderApi";
import {
  selectAuthData,
  getLoginData,
} from "../../../../redux/features/auth/authSlice";
import { useUpdateSingleUserMutation } from "../../../../redux/features/usersManagement/usersManagementApi";
import { useAuth } from "../../../../utils/hooks/useAuth";
import { baseUrlConfig } from "../../../../configurations/configurations";
import { CircularProgress } from "@mui/material";

const PayPalCheckoutButtons = ({ amount }) => {
  // INIT
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useAuth();

  // STATE
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [clientId, setClientId] = useState(null);

  // REDUX
  const newOrder = useSelector(selectOrder);
  // const [completeOrder] = useCompleteOrderMutation();
  const [createOrder] = useCreateNewOrderMutation();
  const [captureOrder] = useCaptureOrderMutation();
  const [updateUser, { isLoading }] = useUpdateSingleUserMutation();
  const userData = useSelector(selectAuthData);
  const userId = userData?.userData?.id;

  const { API_ROOT_URL } = baseUrlConfig.development;
  // EFFECT
  useEffect(() => {
    fetch(`${API_ROOT_URL}/api/v1/paypal-id`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setClientId(data);
      });
  }, [API_ROOT_URL]);

  const handleCreateOrder = async () => {
    const orderDetails = {
      order_amount: parseFloat(newOrder.orderAmount.toFixed(2)),
    };

    try {
      const orderData = await createOrder({
        order_details: orderDetails,
      });

      if (orderData.data.id) {
        return orderData.data.id;
      } else {
        const errorDetail = orderData?.data?.details?.[0];
        const errorMessage = errorDetail
          ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
          : JSON.stringify(orderData);

        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("handleCreateOrder error:", error);
    }
  };

  const handleApprove = async (data, actions) => {
    const orderId = data.orderID;

    console.log("Capturing Order ID:", orderId);
    try {
      const orderData = await captureOrder({
        orderId: data.orderID,
        userId: userId,
      });

      if (orderData.error) {
        actions.redirect(userDashboardRoute.errorPage);
        throw new Error(
          `Sorry, your transaction could not be processed...${orderData.error}`
        );
      } else {
        // (3) Successful transaction -> Show confirmation or thank you message
        // Or go to another URL:  actions.redirect('thank_you.html');
        console.log("Order data success:", orderData);

        // const transaction =
        //   orderData?.data?.purchase_units[0]?.payments?.captures[0];

        //
        // actions.redirect(userDashboardRoute.successPage);
        navigate(userDashboardRoute.successPage);

        dispatch(
          setOrderDetails({
            orderId: null,
            orderAmount: 0,
            credits: 0,
          })
        );

        const newCreditsBalance =
          userData?.userData?.credits + newOrder.credits;
        await updateUser({
          userId: userData?.userData?.id,
          credits: newCreditsBalance,
        });
        dispatch(
          getLoginData({
            ...auth,
            userData: {
              ...userData?.userData,
              credits: newCreditsBalance,
            },
          })
        );
        // navigate(userDashboardRoute.successPage);
      }
    } catch (error) {
      console.error(error);
      setMessage(`Sorry, your transaction could not be processed...${error}`);
    }
  };
  if (!clientId) {
    return <CircularProgress />;
  }

  return (
    <PayPalScriptProvider
      options={{
        "client-id": clientId,
        currency: "EUR",
        intent: "capture",
        locale: "en_US",
      }}
    >
      <PayPalButtons
        createOrder={handleCreateOrder}
        onApprove={handleApprove}
        onCancel={() => {
          navigate(userDashboardRoute.error);
        }}
        onError={(err) => {
          setError(err);

          navigate(userDashboardRoute.errorPage);
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalCheckoutButtons;
